import {combineReducers} from 'redux';
import previewmodule from './previewmodule/reducer';

export default combineReducers({
  previewmodule,
});
